/** external */
import _ from "lodash";
/** external */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { CloseCircleFilled, TickCircleFilled } from "@toddle-edu/ds-icons";
/** internal */
import {
  BLANKS_MIN_WIDTH,
  BLANKS_ANSWER_SEPARATOR,
} from "Worksheet/modules/WorksheetConstants";
import { getStyleStrippedText } from "Utils";
/** relative */
import classes from "./BlanksInput.scss";

const EvaluatedBlank = props => {
  const { value, answerBlock, answerArray, t } = props;

  const isCorrect = _.includes(_.map(answerArray, _.toLower), _.toLower(value));

  const containerClasses = classNames(
    classes.tag,
    { [classes.correct]: isCorrect },
    { [classes.wrong]: !isCorrect },
    { [classes.empty]: _.isEmpty(value) }
  );

  return (
    <span className={classes.container}>
      <span className={containerClasses}>
        {isCorrect ? (
          <TickCircleFilled variant={"success"} />
        ) : !_.isEmpty(value) ? (
          <CloseCircleFilled variant={"critical"} />
        ) : (
          <span>
            {t("common:no_with_label", { label: t("common:response") })}
          </span>
        )}
        {value}
      </span>
      {!_.isEmpty(answerBlock) && !_.isEqual(value, answerBlock) ? (
        <span
          className={classes.answer}
          dangerouslySetInnerHTML={{
            __html: getStyleStrippedText({
              text: answerBlock,
            }),
          }}
        />
      ) : null}
    </span>
  );
};

const InsightBlank = props => {
  const { value } = props;

  const containerClasses = classNames(
    classes.tag,
    classes.insights,
    "text-body-1",
    {
      [classes.empty]: _.isEmpty(value),
    }
  );

  // Answer is in form of string "x;y;z" -> replacing with "x/y/z"
  const blanksAnswer = _.replace(
    value,
    new RegExp(BLANKS_ANSWER_SEPARATOR, "g"),
    "/"
  );
  return <span className={containerClasses}>{blanksAnswer}</span>;
};

const BlanksInput = props => {
  const {
    mode,
    placeholder,
    name,
    value,
    answerBlock,
    answerArray,
    t,
    insightResponse,
    studentCount,
    correctStudentList,
  } = props;
  const toolTipstyles = classNames({
    [classes.tooltipText]: true,
    [classes.tooltipFixedWidth]: placeholder?.length > 48,
  });

  switch (mode) {
    case "insight":
      return (
        <InsightBlank
          value={placeholder}
          t={t}
          insightResponse={insightResponse}
          studentCount={studentCount}
          correctStudentList={correctStudentList}
        />
      );
    case "evaluate":
      return (
        <EvaluatedBlank
          value={value}
          answerBlock={answerBlock}
          t={t}
          answerArray={answerArray}
        />
      );
    default:
      return (
        <span className={classes.tooltipContainer}>
          <input
            dir="auto"
            type="text"
            id="blanks-input"
            placeholder={placeholder}
            className={classes.input}
            disabled={_.includes(["create", "view", "preview"], mode)}
            name={name}
            value={value}
            autoComplete="off"
            autoCapitalize="off"
            spellCheck="false"
            style={{ width: `${BLANKS_MIN_WIDTH}px` }} /** initial width */
            data-test-id="worksheet-blanksInput-blankInputBox"
          />
          {placeholder ? (
            <span className={toolTipstyles}>{placeholder}</span>
          ) : null}
        </span>
      );
  }
};

BlanksInput.propTypes = {
  mode: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.number,
  value: PropTypes.string,
  answers: PropTypes.object,
  showAnswer: PropTypes.bool,
  t: PropTypes.func,
};

export default BlanksInput;
